import { FC } from 'react'

import styled from 'styled-components'

import { colors, device } from 'src/Helpers/constants.ts'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  gap: 10px;
  padding: 10px;
  width: 100%;

  @media ${device.tabletMax} {
    display: none;
  }
`

const ParametersContainer = styled.div`
  display: grid;
  grid-column-gap: 16px;
  grid-template-columns: 1fr 0.5fr 1.5fr 1fr;
  width: calc(100% - 10px);
`

const Parameter = styled.div`
  font-size: 12px;
  max-width: 300px;
  flex-grow: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: ${colors.thirdGray};
  font-weight: 600;
  flex-shrink: 0;
`

const NameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  width: 200px;
`

export const TableHeader: FC = () => {
  return (
    <Container>
      <ParametersContainer>
        <NameWrapper>
          <Parameter>Наименование организации</Parameter>
        </NameWrapper>
        <Parameter>ИНН</Parameter>
        <Parameter>Юридический адрес</Parameter>
      </ParametersContainer>
    </Container>
  )
}
